<template>
  <div>
    <get-weight title="" :domVisible='dislogType.weight' :list="dislogData" :dialogClass="'weight alertWeightList'" @closeDialog="closeDialog" v-if='dislogType.weight' />
  <div class='oversea full_layout' v-loading.fullscreen="disabled">
    <div><img src="/static/images/activty/overseawarehouse/oversea/oversea_01.jpg"></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea/oversea_02.jpg"></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea/oversea_03.jpg"></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea/oversea_04.jpg"><span @click="ShippingFee"></span></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea/oversea_05.jpg"></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea/oversea_06.jpg"></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea/oversea_07.jpg"></div>
  </div>
</div>
</template>
<script>
import bus from '@/api/bus';
import GetWeight from "@/components/dialog/weight"; // 稱重
import { getInfo } from "@/api/public";
export default {
  name: '',
  components: { GetWeight },
  data() {
    return {
      userInfo:null,
      dislogType: this.$enumInfo.dislogType,
      dislogData:{},
      disabled:false
    }
  },
  watch: {
  },
  mounted() {},
  created() {
    bus.$emit('headerTitle', this.$t('title.processIntroduction'));
    this.userInfo = getInfo()
  },
  methods: {
    closeDialog(val, bol) {
      this.dislogType[val] = bol;
    },
    // 获取办事处全部列表
    GetAllAgency() {
      let that = this
      let data = { 'MemberId': that.userInfo.MappingUserId,"MemberSource":that.userInfo.MemberSource }
      that.$get(that.$interface.GetAllAgency, data).then(res => {
        if (res.Result != 0) {
          that.dislogData.agencyId=res.Data[0].AreaId;
          that.dislogData.region=that.userInfo.MemberSource;
          that.dislogType.weight = true;
        }
      })
    },
    ShippingFee() {
      // 价格列表
      let that = this
      //that.loading = true;
      let data = { pageIndex: 1, pageSize: 99,region:'US',agencyId:'CN'}
      that.dislogData=data
      if(that.userInfo!=null){
        that.GetAllAgency()
      }else{
        that.dislogType.weight = true;
      }
    },
  },
}

</script>
<style scoped>
.oversea{
  margin-top: 24px;
}
.oversea img{
  width: 100%;
  display: block;
  overflow: hidden;
}
.oversea>div{
  position: relative;
}
.oversea>div>span{
  position: absolute;
  width: 263px;
    height: 38px;
    top: 193px;
    right: 341px;
    cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/oversea.vue